
export default function(o, subs){

  console.log('subs', subs)

  var subs = subs.split(/\n\s*\n/)

  var subs = _.compact(_.map(subs, function(s){

    console.log("s", !s, s)

    if(!s){
      return
    }

    var l = s.split(/\r?\n/)
    var d = l[1]
    var start = d.split(' --> ')[0]
    var end = d.split(' --> ')[1]
    var startFrames = _.round(start.split(',')[1] * 25 / 1000)
    var endFrames = _.round(end.split(',')[1] * 25 / 1000)
    var startSmpte = start.split(',')[0] + ':' + ('0' + startFrames).slice(0,2)
    var endSmpte = end.split(',')[0] + ':' + ('0' + endFrames).slice(0,2)
    var startSec = o.util.smpteToSeconds(startSmpte)
    var endSec = o.util.smpteToSeconds(endSmpte)
    var text = l.slice(2).join('<br>')

    return {
      s: startSec,
      e: endSec,
      t: text,
    }

  }))

  return subs

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/parseSubs/parseSubs.js